module.exports = __webpack_public_path__ + "static/media/dogenano-airdrop.4af9558c.png";